import { CartService as WbmCartService } from "@wbmason/cart-service";
import { CartService as LegacySignaRCartService } from "wbm-cart-service";
import { CartService } from "./cartService";
import EnvironmentService from "./environmentService";
import { ICartItem } from "../interfaces/ICartItem";

export const CartServiceAccessor = () =>
     EnvironmentService.get().isEcom ? CartService : WbmCartService as unknown as typeof LegacySignaRCartService;

export const GetRemoveCartItemsCall = (cartItem: ICartItem) => {
    if (EnvironmentService.get().isEcom) {
        return CartService.removeItem(cartItem);
    } else {
        return WbmCartService.removeCartItem(cartItem.cartLineRecId.toString(), `cart-slideout`, cartItem.itemIdentifier.id);
    }
}